import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ICountry,
  ITaxDefinition,
} from '@boma/supplier-portal/shared/entities';
import { ProductsService } from '@boma/supplier-portal/shared/services';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import {
  addCountryTaxDefinition,
  removeCountryTaxDefinition,
  updateTaxDefinitions,
} from '../../../../supplier-portal/catalogue/src/lib/containers/add-new-product/+state/add-product.actions';

@Component({
  selector: 'boma-tax-definitions-selector',
  templateUrl: './tax-definitions-selector.component.html',
  styleUrls: ['./tax-definitions-selector.component.scss'],
})
export class TaxDefinitionsSelectorComponent implements OnInit {
  @Input() taxRates = [];
  @Output() updateTaxId = new EventEmitter();

  taxDefinitions: string[] = []; // This won't work if they refresh the page and continue with their crazy submission
  selectedTaxDefinition: '';
  selectedTaxValues: string[];

  city: any;

  addTaxDefinitionFormGroup: FormGroup = new FormGroup({
    country: new FormControl('', Validators.required),
    taxDefinition: new FormControl(''),
  });

  selectedCountryName: string;
  countrySearchSubject = new Subject<string>();
  countrySearchResults: ICountry[];

  countryDetailsSubject = new Subject<string>();
  countryDetailsResults: ITaxDefinition[];

  constructor(
    public store: Store,
    private productService: ProductsService
  ) {}

  ngOnInit(): void {
    this.selectedTaxValues = this.taxRates;
    this.updateTaxId.emit(this.selectedTaxValues); //emit immediately so we have no problems when updating.

    this.countrySearchSubject
      .asObservable()
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(() => {
          return this.productService.getCountries();
        })
      )
      .subscribe((res) => {
        this.countrySearchResults = res;
        this.getTaxDefinitions('none');
      });
    this.countrySearchSubject.next('');
  }

  changeTaxCountry(e: any) {
    this.getTaxDefinitions(this.countrySearchResults[e.index].name);
    this.addTaxDefinitionFormGroup.patchValue({
      name: this.countrySearchResults[e.index].name,
    });
  }

  searchCountry(event) {
    this.countrySearchSubject.next(event.query);
  }

  // TODO no tax definitions on supplier portal
  getTaxDefinitions(e: any) {
    const index = e.index ? e.index : 0;
    const countryName = this.countrySearchResults[index].name;
    this.addTaxDefinitionFormGroup.patchValue({
      country: countryName,
    });

    const ctx = this;
    const selectedCountry = ctx.countrySearchResults.filter((country) => {
      return country.name === countryName;
    });

    this.selectedCountryName = countryName;

    this.countryDetailsResults = selectedCountry[0].taxDefinitions;
  }

  submitTaxDefinition(id = '', selected = '') {
    // Single Selection
    const currentCountryTaxIds = this.countryDetailsResults.map((x) => x?.id);
    const newTaxValues = this.selectedTaxValues.filter(
      (item) => !currentCountryTaxIds.includes(item)
    );
    if (selected) newTaxValues.push(id);
    this.selectedTaxValues = newTaxValues;

    this.updateTaxId.emit(this.selectedTaxValues);
  }
}
